"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientSharedValues = void 0;
exports.ClientSharedValues = {
    lstatSync: () => { },
};
